// extracted by mini-css-extract-plugin
export default {"container":"HistoryWidget_container__6stsq","headerContainer":"HistoryWidget_headerContainer__1LEFy","mobile":"HistoryWidget_mobile__5MCiL"};